import { onboardingModalActionTypes } from './Constants';

export function closeOnboardingModal() {
	return {
		type: onboardingModalActionTypes.CLOSE_ONBOARDING_MODAL,
		payload: {},
	};
}

export function getOnboardingModalRequest(data, parentModalOnClose) {
	return {
		type: onboardingModalActionTypes.GET_ONBOARDING_MODAL_REQUEST,
		payload: { data, parentModalOnClose },
	};
}

export function getOnboardingModalSuccess(data) {
	return {
		type: onboardingModalActionTypes.GET_ONBOARDING_MODAL_SUCCESS,
		payload: { data },
	};
}

export function getOnboardingModalError(error) {
	return {
		type: onboardingModalActionTypes.GET_ONBOARDING_MODAL_ERROR,
		payload: { error },
	};
}

export function clearOnboardingModal() {
	return {
		type: onboardingModalActionTypes.CLEAR_ONBOARDING_MODAL,
		payload: {},
	};
}
